module.exports = __webpack_public_path__ + "assets/img/favicons/apple-icon-114x114.png";